<template>
  <div class="main-content">
    <!-- 标题 -->
    <div class="title">{{ $t('shopcoach.title') }}</div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t('nav.home') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('shopcoach.title') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 搜索栏 -->
    <div class="handle-box">
      <el-row>
        <el-col :span="8">
          <el-select v-model="searchForm.shopId" :placeholder="$t('shopcoach.belongingShop')" clearable @change="fetchCoachList">
            <el-option
              v-for="item in shopOptions"
              :key="item.id"
              :label="item.shopName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-select v-model="searchForm.coachId" :placeholder="$t('shopcoach.coachName')" clearable>
            <el-option
              v-for="item in coachOptions"
              :key="item.id"
              :label="`${item.jiaolianxingming}(${item.jiaolianbianhao})`"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-button type="primary" @click="search">{{ $t('common.search') }}</el-button>
      <el-button @click="reset">{{ $t('common.reset') }}</el-button>
      <el-button type="success" @click="handleAdd">{{ $t('shopcoach.addBinding') }}</el-button>
    </div>

    <!-- 表格 -->
    <div class="table">
      <el-table :data="dataList" border v-loading="dataListLoading" @selection-change="selectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" header-align="center" align="center" width="80" :label="$t('table.id')"></el-table-column>
        <el-table-column prop="shopName" header-align="center" align="center" :label="$t('shopcoach.shopName')"></el-table-column>
        <el-table-column prop="shopAddress" header-align="center" align="center" :label="$t('shop.shopAddress')"></el-table-column>
        <el-table-column prop="coachName" header-align="center" align="center" :label="$t('shopcoach.coachName')"></el-table-column>
        <el-table-column prop="coachId" header-align="center" align="center" :label="$t('shopcoach.coachId')"></el-table-column>
        <el-table-column prop="bindTime" header-align="center" align="center" width="180" :label="$t('shopcoach.bindTime')"></el-table-column>
        <el-table-column header-align="center" align="center" width="150" :label="$t('table.actions')">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">{{ $t('table.edit') }}</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row.id)">{{ $t('table.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;"
      ></el-pagination>
    </div>

    <!-- 添加/修改弹窗 -->
    <el-dialog :title="!dataForm.id ? $t('shopcoach.addBinding') : $t('missingTranslations.editBinding')" :visible.sync="dialogFormVisible" width="40%" @closed="closeDialog">
      <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="100px">
        <el-form-item :label="$t('shopcoach.shopName')" prop="shopId">
          <el-select v-model="dataForm.shopId" :placeholder="$t('missingTranslations.selectShop')" style="width: 100%" @change="fetchAllCoaches">
            <el-option
              v-for="item in shopOptions"
              :key="item.id"
              :label="item.shopName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('shopcoach.coachName')" prop="coachId">
          <el-select v-model="dataForm.coachId" :placeholder="$t('missingTranslations.selectCoach')" style="width: 100%">
            <el-option
              v-for="item in allCoachOptions"
              :key="item.id"
              :label="`${item.jiaolianxingming}(${item.jiaolianbianhao})`"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('missingTranslations.remark')" prop="remark">
          <el-input type="textarea" v-model="dataForm.remark" :placeholder="$t('missingTranslations.remark')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="dataFormSubmit()">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        shopId: '',
        coachId: '',
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      dialogFormVisible: false,
      shopOptions: [],
      coachOptions: [],
      allCoachOptions: [],
      dataForm: {
        id: 0,
        shopId: '',
        coachId: '',
        remark: '',
      },
      dataFormRules: {
        shopId: [
          { required: true, message: '请选择店铺', trigger: 'change' }
        ],
        coachId: [
          { required: true, message: '请选择教练', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getDataList()
    this.getShopOptions()
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        shopId: this.searchForm.shopId,
        coachId: this.searchForm.coachId
      }
      this.$http({
        url: '/shopcoach/page',
        method: 'get',
        params: params
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list
          this.totalPage = data.data.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 获取店铺列表
    getShopOptions() {
      this.$http({
        url: '/shop/list',
        method: 'get'
      }).then(({data}) => {
        console.log("shop",data);
        
        if (data && data.code === 0) {
          this.shopOptions = data.data.list
        }
      })
    },
    // 根据所选店铺获取教练列表
    fetchCoachList() {
      if (this.searchForm.shopId) {
        this.$http({
          url: `/shopcoach/coaches/${this.searchForm.shopId}`,
          method: 'get'
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.coachOptions = data.data
          } else {
            this.coachOptions = []
          }
        })
      } else {
        // 如果没有选择店铺，获取所有教练
        this.$http({
          url: '/jiaolian/list',
          method: 'get'
        }).then(({data}) => {
          console.log("jiaolian",data);
          
          if (data && data.code === 0) {
            this.coachOptions = data.data.list
          }
        })
      }
    },
    // 获取所有可用教练（添加绑定时用）
    fetchAllCoaches() {
      this.$http({
        url: '/jiaolian/list',
        method: 'get'
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.allCoachOptions = data.data.list
        }
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 搜索
    search() {
      this.pageIndex = 1
      this.getDataList()
    },
    // 重置
    reset() {
      this.searchForm = {
        shopId: '',
        coachId: '',
      }
      this.getDataList()
    },
    // 新增
    handleAdd() {
      this.dialogFormVisible = true
      this.dataForm = {
        id: 0,
        shopId: '',
        coachId: '',
        remark: '',
      }
      this.fetchAllCoaches()
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
      })
    },
    // 修改
    handleEdit(row) {
      this.dialogFormVisible = true
      this.dataForm = JSON.parse(JSON.stringify({
        id: row.id,
        shopId: row.shopId,
        coachId: row.coachId,
        remark: row.remark
      }))
      this.fetchAllCoaches()
    },
    // 删除
    handleDelete(id) {
      this.$confirm('确定解除此绑定关系吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/shopcoach/delete',
          method: 'post',
          data: [id]
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: `/shopcoach/${!this.dataForm.id ? 'save' : 'update'}`,
            method: 'post',
            data: this.dataForm
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.dialogFormVisible = false
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    // 添加关闭弹窗处理方法
    closeDialog() {
      this.$refs['dataForm'].resetFields()
      this.dataForm = {
        id: 0,
        shopId: '',
        coachId: '',
        remark: '',
      }
    }
  }
}
</script>

<style scoped>
.main-content {
  padding: 20px;
}
.handle-box {
  margin-bottom: 20px;
}
.el-row {
  margin-bottom: 10px;
}
.el-col {
  padding-right: 10px;
}
</style> 